import { Injectable, NgZone } from '@angular/core';
import { App } from '@capacitor/app';
import { from, fromEventPattern } from 'rxjs';
import { AppLauncher } from '@capacitor/app-launcher';
import { Platform } from '@ionic/angular';
import { filter, switchMap, tap } from 'rxjs/operators';
import { PluginListenerHandle } from '@capacitor/core';
import { environment } from '#environment';
import { URLOpenListenerEvent } from '@capacitor/app/dist/esm/definitions';
import { AccessAppUnavailableError } from './error/AccessAppUnavailableError';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    private readonly platform: Platform,
    private readonly zone: NgZone
  ) {}

  public switchToAccessApp = (url: string) =>
    from(this.checkIfAccessAppIsAvaialable()).pipe(
      tap((isAvailable) => {
        if (!isAvailable) {
          throw new AccessAppUnavailableError();
        }
      }),
      switchMap(() => AppLauncher.openUrl({ url })),
      filter(({ completed }) => completed === true),
      switchMap(() =>
        fromEventPattern<URLOpenListenerEvent>(
          (handler) => App.addListener('appUrlOpen', (event) => this.zone.run(() => handler(event))),
          (_handler, listener: PluginListenerHandle) => listener.remove()
        )
      )
    );

  private checkIfAccessAppIsAvaialable() {
    if (this.platform.is('android')) {
      return AppLauncher.canOpenUrl({ url: environment.accessApp.appId }).then(({ value }) => value);
    } else if (this.platform.is('ios')) {
      return AppLauncher.canOpenUrl({ url: environment.accessApp.uri }).then(({ value }) => value);
    } else {
      return Promise.resolve(false);
    }
  }
}
